import galleryRoute from './Gallery/GalleryPage';
import { permission as GalleryScreenPermissionId } from './Gallery/GalleryPage/constants';
import { galleryLink } from './Gallery/GalleryPage/navigation';
import trackerRoute from './Trackers/Tracker';
import { permission as TrackerScreenPermissionId } from './Trackers/Tracker/constants';
import { trackerLink } from './Trackers/Tracker/navigation';

const routes = [trackerRoute, galleryRoute];

export const getDefaultPartnersRoute = (pageIds) => {
  if (
    pageIds.includes(TrackerScreenPermissionId) &&
    pageIds.includes(GalleryScreenPermissionId)
  ) {
    return trackerLink;
  }
  if (pageIds.includes(GalleryScreenPermissionId)) {
    return galleryLink;
  }
  return trackerLink;
};

export default ({ children }) => {
  return children({
    screens: routes,
    getDefaultScreenLink: getDefaultPartnersRoute,
  });
};
